<template>
  <div class="page border-box" v-wechat-title="$route.meta.title">
    <!--<img class="top-bg" src="../../assets/new-index/top-bg.png" alt="">-->
    <!--搜索-->
    <div class="top-fixed-box">
      <div class="station-search border-box box">
        <div class="location l clearfix" @click="toCity" v-if="searchListShow!=1">
          <img class="fl icon-dw" src="../../assets/new-index/icon-dw.png" alt="">
          <span class="fl hide city flex" v-show="loadEnd">{{cityInfo.city || '全国'}}</span>
          <img class="fl icon-d" src="../../assets/new-index/icon-d.png" alt="">
        </div>
        <div class="flex station-search-con box">
          <form class="station-search-bar border-box flex" action="." v-on:submit.prevent="search"
                @click="searchListShow=1">
            <img class="station-search-icon" src="../../assets/icon-search.png" alt="" @click.stop='search'>
            <input type="search" class="station-search-input" placeholder="搜索景区名称" value="" v-model='inputValue'/>
            <img class="station-input-close none" src="../../assets/input-close.png" alt="" v-show="inputValue"
                 @click.stop="inputValue=''">
          </form>
          <div class="search-history-cancel flex" v-if="searchListShow==1" @click.stop="searchListShow=0">取消</div>
        </div>
        <div class="search-history-list border-box" v-if="searchListShow==1">
          <p class="search-history-tit" v-if="history.length > 0">
            搜索历史 <img src="../../assets/icon_01.png" alt="" @click="delHistory"></p>
          <p class="search-history-my clearfix">
            <span v-for="(item,index) in history" @click="searchHistory(item)">{{item}}</span>
          </p>
        </div>
      </div>
    </div>

    <!-- 热门城市 -->
    <div class="main-hot-city border-box" v-if="!siteid">
      <div v-if="hotcity!=null&&hotcity.length>1">
        <div class="hot-citys clearfix">
          <p class="hot-citys-name hide" v-for="(item,index) in hotcity" @click="citySelected(item.city,item.code)">{{item.city}}</p>
        </div>
      </div>
    </div>

    <!--轮播图-->
    <div class="banner border-box">
      <Swiper :banners="banners" :type="'home'"></Swiper>
    </div>

    <!--VR+限时免费试听-->
    <div class="vr-box border-box" :class="loadEnd && !freeImg?'no-vr':''" v-if="loadEnd && vrRes.root!=null && vrRes.root.length>0">
      <div class="vr-con border-box clearfix">
        <span class="m-line"></span>
        <!--VR虚拟全景视频-->
        <div class="vr-info vr-l border-box" v-if="vrRes.root!=null && vrRes.root.length>0">
          <div class="list-tit"><span><font>5G真人VR讲解</font></span>
          </div>
          <router-link v-if="vrRes.root" class="vr border-box" :to="{path:'/video-vrlist',query: {order: 1,citycode:cityInfo.citycode, siteid:siteid, sregion:sregion, appKey: appKeyA}}">
            <div class="vr-name hide">{{vrRes.root[0].name}}</div>
            <div class="vr-img-box">
              <img class="icon" src="../../assets/icon_360.png" alt="">
              <div class="img" id="vr-img" v-if="vrRes.root[0].vrimg&&vrRes.root[0].vrimg!=''&&vrRes.root[0].vrimg!=null"></div>
              <img class="img" v-lazy="vrRes.root[0].tvideourl" alt="" v-else>
            </div>
          </router-link>
        </div>
        <div class="vr-info vr-r border-box" v-if="freeImg&&loadEnd">
          <div class="list-tit"><span><font>限时免费试听</font></span></div>
          <router-link class="vr border-box" :to="{path:'/view-free',query:{siteid:siteid,TimeStamp:TimeStamp,inputValue:inputValue,appKey:appKeyA}}">
            <!--<div class="vr-name hide">VR云游中国700家文博景区</div>-->
            <div class="vr-name hide">广东民间工艺博物馆</div>
            <div class="vr-img-box">
              <img class="fl img" :src="freeImg.left" alt="">
              <img class="fr img" :src="freeImg.right" alt="">
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <!--热门景区-->
    <div class="hot-scenic border-box" v-if="total1>0&&loadEnd">
      <div class="hot-scenic-con border-box">
        <div class="list-tit">
          <span><font>热门景区</font></span>
          <router-link class="list-more" v-if="total1>2" :to="{path:'/view-list',query:{siteid:siteid,TimeStamp:TimeStamp,inputValue:inputValue,appKey:appKeyA,sort:0}}">更多
            <img src="../../assets/new-index/icon-r.png" alt="">
          </router-link>
        </div>
        <div class="hot-scenic-list clearfix" :class="'item'+total1">
          <div class="fl hot-scenic-item" @click="toViewDetail(item.id,item.shopType)"  v-for="(item,index) in hot">
            <div class='item border-box'>
              <div class="item-img loadBg">
                <img class="img" v-lazy="item.logo" :key="item.id" alt="">
              </div>
              <div class="item-title hide">{{item.name}}</div>
              <div class="item-num hide">{{item.listen|initNumber}}人收听</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--金牌讲解员-->
    <div class="guide-box border-box clearfix" v-if="loadEnd && bagList!=null&&bagList.length>0">
      <div class="list-tit"><span><font>金牌解说员</font></span>
        <div class="list-more" style="margin-right: .3rem;" v-if="bagTotal>6" @click="toWaterfall()">更多<img src="../../assets/new-index/icon-r.png" alt=""></div>
      </div>
      <div class="guide-list border-box">
        <div class="guide-item" v-for="(item,index) in bagList" @click="goVideoPlay(item.id,item.shopid)">
          <div class="guide-img">
            <img class="img" v-lazy="item.headimg" :key="item.id" alt="">
          </div>
          <div class="guide-bot border-box">
            <div class="guide-name"><span class="fl l hide" style="max-width: 70%;">{{item.guidename}}</span><span class="fr r">{{item.listens|initNumber}}</span></div>
            <div class="bag-name hide" v-if="item.guidetag">{{item.guidetag}}</div>
          </div>
        </div>
      </div>
    </div>

    <!--景区列表切换-->
    <div class="tab-scenic border-box">
      <span :class="tabScenic==0?'curr':''" @click="tabScenicFun(0)" v-if="total2>0&&loadEnd">附近景区</span>
      <span :class="tabScenic==1?'curr':''" @click="tabScenicFun(1)" v-if="last&&last.length>0&&loadEnd">最新上线</span>
      <!--<span :class="tabScenic==2?'curr':''" @click="tabScenicFun(2)">必打卡景区</span>-->
    </div>

    <!--最新上线-->
    <div class="scenic-list-box border-box clearfix" v-if="last&&last.length>0&&loadEnd&&tabScenic==1">
      <ul class="fl list">
        <li class="border-box" :class="index==0?'curr':''" v-for="(item,index) in last" :key="index" @click="toViewDetail(item.id,item.shopType)" v-if="index%2==0">
          <div class="img-box">
            <img class="img" v-lazy="item.logo" alt="">
          </div>
          <div class="item-info border-box box">
            <div class="l flex">
              <div class="item-name hide">{{item.name}}</div>
              <div class="item-num">{{item.spots}}个讲解点</div>
            </div>
            <div class="r"></div>
          </div>
        </li>
      </ul>
      <ul class="fr list" v-if="last.length>1">
        <li class="border-box" v-for="(item,index) in last" :key="index" @click="toViewDetail(item.id,item.shopType)" v-if="index%2!=0">
          <div class="img-box">
            <img class="img" v-lazy="item.logo" alt="">
          </div>
          <div class="item-info border-box box">
            <div class="l flex">
              <div class="item-name hide">{{item.name}}</div>
              <div class="item-num">{{item.spots}}个讲解点</div>
            </div>
            <div class="r"></div>
          </div>
        </li>
      </ul>
    </div>

    <div v-if="tabScenic==0&&total2>0&&loadEnd">
      <div class="scenic-list-box border-box clearfix" v-if="total2>0&&loadEnd">
        <ul v-if="newWaterfallData!=undefined" class="fl list" v-for="(el,ind) in newWaterfallData" :key="ind">
          <li class="border-box" :class="ind==0&&index==0?'curr':''" v-for="(item,index) in el" :key="index" @click="toViewDetail(item.id,item.shopType)">
            <div class="img-box">
              <img class="img" v-lazy="item.logo" alt="">
            </div>
            <div class="item-info border-box box">
              <div class="l flex">
                <div class="item-name hide">{{item.name}}</div>
                <div class="item-num">{{item.listen|initNumber}}人收听</div>
              </div>
              <div class="r"></div>
            </div>
          </li>
        </ul>
      </div>
      <p class="load-tip">{{loadText}}</p>
    </div>


    <!--红包活动弹窗(攀枝花类型的普通红包)-->
    <AlertRedEnvelNew  :redEnvelNew="redEnvelNew" @close="closeEnvelope" v-if="Object.keys(redEnvelNew).length>0"></AlertRedEnvelNew>

    <!--底部导航栏-->
    <Foot :siteid="siteid" :sregion="sregion" :appKeyA="appKeyA" :citycode="cityInfo.citycode" ></Foot>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>

  </div>


</template>
<!--<script type="text/javascript" src="//pingjs.qq.com/h5/hotclick.js?v2.0" name="mtah5hotclick" sid="500693284" hid="5d565901f063a"></script>-->
<script>
  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import Swiper from '../../components/Swiper'
  import Foot from '../../components/Foot'
  import P400 from '../../components/P400'
  import {getIndex,getHotCity,uploadUserBrowse,getEnvelope,getGuides,getNear} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo, getHotCity1} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import AlertRedEnvelNew from '../../components/AlertRedEnvelNew'

  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        sregion: '', //省站点id:430000
        cityName: '',
        siteid: '', //站点id
        userInfo: {}, //用户信息
        userInfo1: {}, //用户信息
        latlng: {lat: '', lng: ''}, //经纬度信息
        cityInfo: { citycode: this.$route.query.code||"1", city: "全部", address: "" },
        banners: [],
        hotcity: [], //热门城市
        last: [],//最新上线
        hot: [],//热门景区
        near: [],//附近景区
        newWaterfallData: '',//附近景区瀑布流数组
        vrRes:'',//VR视频
        total1: 0, //热门景区总数
        total2: 0, //附近景区总数
        inputValue: '',//搜索关键词
        loadEnd: false, //数据加载结束则赋值为true
        redEnvelNew: [], //攀枝花类型的普通红包

        loadText: "加载更多",
        page: 1, //附近的加载更多

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',

        searchListShow: 0, //搜索历史
        history: [], //历史记录

        cityCard: null,//城市名片
        bagTotal: 0, //导游专辑总数
        bagList: [], //导游专辑列表

        P400: 0, //系统维护中
        PSV: null, //全景图片
        tabScenic:0,//0：附近景区 1：最新上线 2：必打卡景区
        freeImg:'',//限时免费试听图片
      }
    },
    computed: {},

    beforeRouteLeave (to, from, next) {
      if(to.path.indexOf('waterfall') > -1){
        to.meta.keepAlive = false;
      }
      next();
    },
  created() {
      let self = this;
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.userInfo1 = getStore("userInfo1",1);

      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey);
        setStore("appKey", {"appKey": this.appKey});
        this.sendUserBrowse();
        this.getActivity();
      } else {
        setStore("appKey", {"appKey": ""});
      }

      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }

      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }

      let cityInfo = getStore("cityInfo"), siteid = this.$route.query.siteid || "";
      if ((cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == "") || (siteid && (cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == ""))) {
        getCityInfo(function (res) {
          self.latlng = res;
          if (siteid) {
            self.cityInfo = getStore("cityInfo")
          } else {
            self.cityInfo = { citycode: "1", city: "全国", address: "" };
            setStore("cityInfo",self.cityInfo);
          }
          self.initData();
          self.getGuidesData();
        });
      } else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function (res) {
          self.latlng = {lat: res.latitude, lng: res.longitude};
          self.initData();
          self.getGuidesData();
        });
      }

      let history = getStore("history", 1) || "";
      if (history) {
        this.history = history.history
      }

      window.addEventListener("scroll",this.handleFun)
//      statisticalData();
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
      if (this.PSV) {
        this.PSV.destroy()
      }
    },
    methods: {
      //初始化：获取景区数据
      async initData(){
      this.loadEnd = false;

      //获取热门城市
      var self = this;
      getHotCity1(this.sregion, function (resCity) {
        if (resCity.errcode == "00000") {
          self.hotcity = resCity.data.hotcity;
        } else {
          self.$toast(resCity.errmsg)
          self.P400 = 1;
          self.$route.meta.title = '请稍后访问...';
        }
      });

      //获取景区数据
      let resView = await getIndex({
        openid: this.userInfo.openid,
        TimeStamp: this.TimeStamp,
        siteid: this.siteid,
        code: this.cityInfo.citycode || '1',
        lat: this.latlng.lat || '',
        lng: this.latlng.lng || '',
        page1: 1,
        rows1: 6,
        page2: 1,
        rows2: 10,
        sregion: this.sregion
      });
      if (resView.errcode == "00000") {
        var self = this;
        this.$loading.hide();
        this.loadEnd = true;

        this.cityCard = resView.data.cityCard;
        this.last = resView.data.last;
        this.hot = resView.data.hot.root;
        this.total1 = resView.data.hot.total;
        this.banners = resView.data.imgurls;
        this.freeImg = resView.data.free;
        this.total2 = resView.data.near.total;
        if(this.total2>0||(this.total2>0&&this.last.length>0)){
          this.tabScenic = 0;
        }else if(this.total2==0&&this.last.length>0){
          this.tabScenic = 1;
        }else{
          this.tabScenic = '';
        }
        let near = resView.data.near.root;
        if(this.near == null){
          this.near = [];
          this.loadText = '已经到底了'
        }

        if(near.length>0){
          self.near = [...self.near, ...near];
          let [ ...waterfallData ]  = self.near;
          let [ ...newWaterfallData ]= [[],[]];
          this.near.forEach((el,i) => {
            switch( i%2 ) {
            case 0 : newWaterfallData[0].push(el)
              break
            case 1: newWaterfallData[1].push(el)
              break
            }0
          });
          self.newWaterfallData = [newWaterfallData[0],newWaterfallData[1]]
        }
        this.vrRes = resView.data.vr;
        this.ids = resView.data.ids || "";

        if (this.sregion) {
          if (resView.data.city) {
            this.cityInfo.citycode = resView.data.citycode;
            this.cityInfo.city = resView.data.city;
            setStore("cityInfo", this.cityInfo);
          }
        }
        this.$route.meta.title = resView.data.head;
        let title = resView.data.title;
        let desc = resView.data.desc;
        let img = resView.data.logo;
        let link = '/?siteid=' + this.siteid + '&sregion=' + this.sregion + '&appKey=' + this.appKey;
        wxShareme(title, desc, img, link);

      } else {
        this.$loading.hide();
      }
    },

    async getNearlist(page){
      let res = await getNear({
        TimeStamp: this.TimeStamp,
        siteid: this.siteid,
        code: this.cityInfo.citycode || '1',
        lat: this.latlng.lat || '',
        lng: this.latlng.lng || '',
        page: page,
        rows: 10,
        sregion: this.sregion,
        ids: this.ids
      });
      if (res.errcode == "00000") {
        var self = this;
        this.$loading.hide();
        var total = res.data.near.total;
        var near = res.data.near.root;
        if (page >= Math.ceil(total / 10)) {
          this.loadText = '已经到底了'
        } else {
          this.loadText = '加载更多'
        }
        if (near.length > 0) {
          self.near = [...self.near, ...near];
          let [ ...waterfallData ]  = self.near;
          let [ ...newWaterfallData ]= [[],[]];
          this.near.forEach((el,i) => {
            switch( i%2 ) {
            case 0 : newWaterfallData[0].push(el)
              break
            case 1: newWaterfallData[1].push(el)
              break
            }
          });
          self.newWaterfallData = [newWaterfallData[0],newWaterfallData[1]]

        } else {
          if (page == 1) {
  //          document.documentElement.scrollTop = document.body.scrollTop = 0;
            this.near = [];
            this.newNear = [[],[]];
            this.loadText = '暂无数据'
          } else {
            this.loadText = '已经到底了'
          }
        }

      } else {
        this.$loading.hide();
      }
    },

    handleFun: function (){
      let self = this;
      self.$nextTick(function() {
        if(self.ids && self.tabScenic!=1){
          loadMore(self,function(page){
            self.getNearlist(page);
          });
        }
      })
    },

    //上传浏览数据
    async sendUserBrowse(){
      let res = await uploadUserBrowse({
        TimeStamp: this.TimeStamp,
        openid: this.userInfo.openid,
        appKey: this.appKey,
      });
    },

    //获取红包活动数据
    async getActivity(){
      let res1 = await getEnvelope({
        TimeStamp: this.TimeStamp,
        openId: this.userInfo.openid,
        type: 0,
        shopId: ''
      });

      if (res1.errcode == '00000' && res1.errmsg == 'SUCCESS' && res1.data.length > 0) {
        if(res1.data[0].model == 1){ //红包活动弹窗（攀枝花类型的普通红包）
          res1.data[0].takeEnvelope = 0;
          this.redEnvelNew = res1.data[0].coupon;
        }
      }
    },
    //关闭活动弹窗
    closeEnvelope(msg){
      this.redEnvelopes = msg.redEnvelopes;
      if(msg.redEnvelNew1){
        this.redEnvelNew = [];
        if(msg.type == 0){
          this.$toast('领取成功，购买专辑立减哟');
        }
      }
    },

    //获取导游列表
    async getGuidesData(){
      let res = await getGuides({
        TimeStamp: this.TimeStamp,
        siteid: this.siteid,
        code: this.cityInfo.citycode || '1',
        sregion: this.sregion
      });
      if (res.errcode == "00000") {
        this.$loading.hide();

        this.bagTotal = res.data.total;
        this.bagList = res.data.data;

      }
    },

    //选择城市
    citySelected(city, citycode){
      MtaH5.clickStat("home_hot_city");
      let cityInfo = {citycode: citycode, city: city, address: ""};
      setStore("cityInfo", cityInfo);
      this.cityInfo = cityInfo;
      this.inputValue = "";

      this.$loading.show('数据加载中');

      this.cityCard = null;
      this.last = {};
      this.hot = [];
      this.near = [];
      this.banners = [];
      this.page = 1;
      this.loadText = '加载更多';
      this.initData();

      this.bagTotal = 0;
      this.bagList = [];
      this.getGuidesData();
    },

    //删除历史记录
    delHistory(){
      let self = this;

      this.$confirm({
        title: '提示',
        content: '确认删除全部历史记录？',
        component: wxConfirm
      }).then(function (res) {
        if (res == 'success') {
          self.history = [];
          setStore("history", {"history": []}, 1);
        }
      }).catch(function (res) {
        if (res == 'success') {
          self.history = [];
          setStore("history", {"history": []}, 1);
        }
      })
    },

    //发送搜索信息inputVaule
    search(){
      this.inputValue = this.inputValue.replace(/(^\s*)|(\s*$)/g, "");
      if (this.inputValue == '') {
        this.$toast('请输入搜索关键词')
      }else if(this.inputValue.indexOf('%')>-1 || this.inputValue.indexOf('_')>-1){
        this.$toast('关键词不能包含特殊字符')
      }else {
        if (this.history.indexOf(this.inputValue) < 0) {
          this.history.unshift(this.inputValue);
        }
        if(this.history.length > 10){
          this.history = this.history.slice(0,10);
        }
        setStore("history", {"history": this.history}, 1);
        this.searchHistory(this.inputValue);
      }
    },

    //搜索某一条
    searchHistory(inputValue){
      this.$router.push({
        path: `/home-search?${'inputValue=' + inputValue + '&TimeStamp=' + this.TimeStamp+'&siteid='+ this.siteid + '&citycode=' + this.cityInfo.citycode + '&sregion=' + this.sregion + '&appKey=' + this.appKey}`
      });
    },

    toViewDetail(id,shopType){
      MtaH5.clickStat('home_to_view');
      if(shopType == "buddhism"){
        this.$router.push({
          path: `/view-detail-sm?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      }else if(shopType == "bagscenic"){
        this.$router.push({
          path: `/view-detail-group?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      }else {
        this.$router.push({
          path: `/view-detail?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      }

    },

    toCity(){
      MtaH5.clickStat("home_location");
      this.$router.push({
        path: `/city?${'siteid='+ this.siteid + '&citycode=' + this.cityInfo.citycode + '&sregion=' + this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+ this.appKey}`
      });
    },

    //城市名片
    toCityCard(region){
      this.$router.push({
        path: `/city-card?${'citycode='+ region + '&TimeStamp='+ this.TimeStamp+'&appKey='+ this.appKey}`
      });
    },

    //跳转到专辑详情页
    goVideoPlay(id,shopid){
      this.$router.push({
        path: `/video-play?${'id='+id+'&shopid='+shopid+'&TimeStamp='+this.TimeStamp+'&siteid='+ this.siteid + '&citycode=' + this.cityInfo.citycode + '&sregion=' + this.sregion+'&appKey='+this.appKey}`
      });
    },

    //跳转到专辑瀑布流页面
    toWaterfall(){
      this.$router.push({
        path: `/waterfall?${'siteid='+ this.siteid + '&citycode=' + this.cityInfo.citycode + '&sregion=' + this.sregion + '&inputValue=' + this.inputValue + '&TimeStamp='+ this.TimeStamp+'&appKey='+ this.appKey}`
      });
    },
    convertImageToBase64(url, callback) {
      const img = new Image();
      // 设置图片的src属性为提供的URL
      img.crossOrigin = 'Anonymous'; // 允许跨域图像
      img.src = url;

      img.onload = function() {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0);

        // 调用toDataURL获取Base64编码的图片数据
        const base64Data = canvas.toDataURL('image/jpeg'); // 可以指定图片格式，如'image/png'，默认为'image/png'

        callback(base64Data);
      };

      // 监听图片加载失败
      img.onerror = function() {
        callback(null); // 图片加载失败时，回调函数返回null
      };
    },
    showPhotoVR(imgurl,obj){
      //        var imgurl = require('../../assets/qj.jpg');
        this.PSV = PhotoSphereViewer({
          container: obj,
          panorama: imgurl,
          autoload: true, //自动播放
          time_anim: 2000, //默认2000
          anim_speed: '2rpm', //默认2rpm
          navbar: false  //不显示下面的导航栏
        });
    },

    tabScenicFun(id){
      this.tabScenic = id;
    }

  },
  watch:  {
    vrRes(){
      var self = this;
      this.$nextTick(function(){
        if(self.vrRes.root!=null && self.vrRes.root.length>0 && self.vrRes.root[0].vrimg && self.vrRes.root[0].vrimg != '' && self.vrRes.root[0].vrimg != null){
          self.showPhotoVR(self.vrRes.root[0].vrimg,'vr-img');
        }
      })
    },
  },
  components: {Swiper,AlertRedEnvelNew,Foot,P400},
  //格式化数据
  filters: {
    initNumber: function (num) {
      if (num > 10000) {
        num = (num / 10000).toFixed(2) + '万'
      } else if (num > 1000) {
        num = (num / 1000).toFixed(2) + '千'
      }
      return num;
    }
  }
  }

</script>

<style scoped>
  @import "../../style/view.css";

  .page{padding-top:1.18rem;padding-bottom:1.4rem;min-height: 100vh;background: #ededed url(../../assets/new-index/top-bg.png) no-repeat;background-size: 100% auto;background-attachment: fixed;}
  /*.top-bg{position: fixed;top:0;left: 0;width: 100%;height: auto;}*/

  /*标题样式*/
  .list-tit{position:relative;font: bold .34rem/.54rem "Microsoft YaHei";color: #222;}
  .list-tit span{position:relative;}
  .list-tit span:after{content: '';position: absolute;left: 0;right:0;bottom:.08rem;height: .08rem;background: #ffc200;}
  .list-tit span font{position: relative;z-index: 1;}
  .list-more{float:right;padding:0 .07rem;color:#333;font: bold .28rem/.54rem "Microsoft YaHei";}
  .list-more img{width:.11rem;height:.2rem;vertical-align: top;margin-top: .17rem;margin-left: .08rem;}


  /*搜索*/
  .top-fixed-box{position:fixed;top:0;left:0;z-index:99;width:100%;height:1.18rem;background:#ededed;}
  .station-search{position:absolute;top:0;left:0;width: 100%;height: 100%;padding:.27rem .3rem;border-radius: .34rem .34rem 0 0;background:#fff;}
  .location{margin-right: .35rem;}
  .location .icon-dw{width: .26rem;height: .32rem;vertical-align: top;margin-top: .16rem;margin-right: .06rem;object-fit: contain;}
  .location .city{display: inline-block;max-width:1.5rem;font: bold .32rem/.64rem "Microsoft YaHei";color: #222;vertical-align: top;}
  .location .icon-d{width: .2rem;height: .12rem;vertical-align: top;margin-top: .26rem;margin-left: .12rem;object-fit: contain;}
  .station-search-con{position:relative;z-index:99}
  .station-search-bar{display:block;margin-top:0;height:.64rem;border-radius:.32rem;line-height:.64rem}
  .station-search-input{left:.64rem;height:.64rem;line-height:.64rem}
  .station-search-icon{position: absolute;top: 50%;left: 0;right: inherit;z-index: 999;padding: 0.2rem 0.15rem 0.2rem 0.24rem;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .station-input-close{position:absolute;top:50%;right:.5rem;z-index:999;padding:.2rem;width:.19rem;height:.19rem;-webkit-transform:translateY(-50%);transform:translateY(-50%)}

  /*搜索记录*/
  .search-history-cancel{padding-left:.24rem;width:1.8rem;height:.68rem;color:#2671fb;text-align:center;font-size:.28rem;line-height:.68rem}
  .search-history-list{position:fixed;top:0;left:0;z-index:98;padding:1.48rem .3rem .3rem 0;width:100%;height:100%;background:#fff}
  .search-history-tit{position:relative;padding-left:.4rem;height:.4rem;color:#343434;line-height:.4rem}
  .search-history-tit img{position:absolute;top:.05rem;right:0;width:.28rem;height:.3rem}
  .search-history-my span{float:left;margin-top:.3rem;margin-left:.5rem;color:#000;font-size:.28rem}

  /* 热门城市 */
  .main-hot-city{position: relative;padding: 0 .3rem;background: #fff;}
  .hot-citys{width:100%;white-space: nowrap;overflow-x: auto;}
  .hot-citys .hot-citys-name{display: inline-block;margin-right: .16rem;margin-bottom: .15rem;width: auto;padding: 0 .16rem;height: .4rem;background: #f2f2f2;color: #666;text-align: center;font: bold .24rem/.4rem "Microsoft YaHei";border-radius: .2rem;}
  /*.hot-citys .hot-citys-name:nth-of-type(5n){margin-right:0}*/

  /* banner */
  .banner{position:relative;padding: 0.15rem .3rem 0;height: 2.95rem;overflow: hidden;}

 /*VR+限时免费试听*/
  .vr-box{position: relative;width: 100%;height: 3.36rem;padding: .26rem .3rem 0;background: #ededed;}
  .vr-box .vr-con{position:relative;width:100%;height:100%;padding:.2rem .26rem .24rem;border-radius: .2rem;background: #fff;border-top: .04rem solid #ff9400;}
  .vr-box .m-line{position: absolute;top:0;left: 50%;bottom:0;z-index:1;width: 1px;background: #e8e4e5;}
  .vr-box .list-tit{font-size: .32rem;}
  .vr-box .vr-info{float:left;width: 50%;}
  .vr-box .vr-l{padding-right: .26rem;}
  .vr-box .vr-name{font-size: .24rem;color: #999;}
  .vr-box .vr-img-box{ position: relative; display: block;width:100%;height: 1.69rem;margin-top:.12rem;border-radius: .14rem;overflow: hidden;}
  .vr-box .vr .img{position:relative;z-index:1;border-radius: .1rem;overflow: hidden;}
  .vr-box .vr .icon{position: absolute;z-index: 2;top:50%;left: 50%;width: auto;height:.61rem;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .vr-box .vr-r{padding-left: .26rem;}
  .vr-box .vr-r .vr-img-box{border-radius: 0;}
  .vr-box .vr-r .vr-img-box .img{width: calc(50% - .13rem);height: 100%;border-radius:0;}
  .vr-box .vr-r .vr-img-box .img.fl{margin-right:.13rem; }
  .vr-box .vr-r .vr-img-box .img.fr{margin-left:.13rem; }
  .vr-box.no-vr{height: 4.46rem;}
  .vr-box.no-vr .vr-name{font-size: .28rem;color: #999;}
  .vr-box.no-vr .m-line{display: none;}
  .vr-box.no-vr .vr-info{width: 100%;padding-right: 0;}
  .vr-box.no-vr .vr-img-box{height: 2.79rem;}

  /*热门景区*/
  .hot-scenic{position: relative;width: 100%;padding: 0 .3rem;padding-top: .18rem;background: #ededed;}
  .hot-scenic-con{position:relative;width:100%;height:100%;padding:.2rem .24rem .1rem;border-radius: .2rem;background: #fff;}
  .hot-scenic-item{width:31.8%;height: 2.85rem;margin-top:.24rem;margin-right: 2.3%;margin-bottom: .25rem;}
  .hot-scenic-item:nth-of-type(3n),.item1 .hot-scenic-item,.item2 .hot-scenic-item:nth-of-type(2n){margin-right: 0;}
  .item-img{position:relative;width: 100%;height: 2.04rem;border-radius: .12rem;overflow: hidden;}
  .item-title{font: bold .3rem/.4rem "Microsoft YaHei";color: #222;margin-top: .06rem;}
  .item-num{font: .22rem/.32rem "Microsoft YaHei";color: #999;margin-top: .06rem;}
  .item1 .hot-scenic-item{width: 100%;height: 3.45rem;}
  .item2 .hot-scenic-item{width: 48.85%;height: 3.45rem;}
  .item1 .item-img,.item2 .item-img{height: 2.64rem;}

  /*金牌讲解员*/
  .guide-box{position: relative;padding-top: .38rem;padding-left: .3rem;background: #ededed;}
  .guide-list{width:100%;margin-top: .28rem;border-radius: 0.13rem;white-space: nowrap;overflow-x: auto;}
  .guide-item{display: inline-block;width: 2.88rem;height:4.64rem;margin-right: .16rem;border-radius: .13rem;background: #fff;overflow: hidden;vertical-align: top;}
  .guide-img{height: 3.4rem;border-radius: .13rem .13rem 0 0;}
  .guide-bot{padding: .14rem .16rem 0;}
  .guide-name{height:.5rem;}
  .guide-name .l{font: bold .3rem/.5rem "Microsoft YaHei";color: #333;}
  .guide-name .r{font: .2rem/.5rem "Microsoft YaHei";color: #666;}
  .bag-name{height: .32rem;margin-top:.05rem;padding-left: .51rem;padding-right:.1rem;font:.22rem/.32rem "Microsoft YaHei";color:#040101;background: #ffc000 url(../../assets/new-index/icon-tag.png) no-repeat left;background-size: auto 100%;border-radius: .06rem;overflow: hidden;}

  /*景区列表切换*/
  .tab-scenic{position: relative;height: .88rem;padding: .24rem .3rem 0;white-space: nowrap;overflow-x: auto;background: #ededed;overflow-y: hidden;}
  .tab-scenic span{position:relative;display: inline-block;margin-right:.46rem;font: bold .3rem/.64rem "Microsoft YaHei";color: #333;}
  .tab-scenic span.curr{font-size: .34rem;}
  .tab-scenic span.curr:after{content: '';position: absolute;bottom:0;left: 50%;width: .44rem;height: .06rem;margin-left: -.22rem;border-radius: .06rem;background: #ff9400;}
  .scenic-list-box{position: relative;padding: .14rem .3rem 0;background: #ededed;}
  .scenic-list-box ul{width: 48.8%;}
  .scenic-list-box ul:nth-of-type(2n+1){margin-right: 2.4%;}
  .scenic-list-box li{margin-top:.16rem;border-radius: .13rem;background: #fff;overflow: hidden;}
  .scenic-list-box li.curr .item-info{background: #ffc000;}
  .scenic-list-box .item-info{padding: .14rem .21rem .24rem .24rem;background: #fff;}
  .scenic-list-box .item-name{font: bold .3rem/.5rem "Microsoft YaHei";color: #333;}
  .scenic-list-box .item-num{font: .22rem/.32rem "Microsoft YaHei";color: #999;}
  .scenic-list-box li.curr .item-name,.scenic-list-box li.curr .item-num{color: #030201;}
  .scenic-list-box .img-box .img{display:block;border-radius: .13rem .13rem 0 0;overflow: hidden;}
  .scenic-list-box .item-info .r{width: .44rem;height: .44rem;margin-top: 0.37rem;margin-left: 0.12rem;background: url(../../assets/new-index/icon-to-listen0.png) no-repeat center;background-size: contain;}
  .scenic-list-box li.curr .item-info .r{background: url(../../assets/new-index/icon-to-listen1.png) no-repeat center;background-size: contain;}
</style>
<style>
  .banner .swiper-pagination-bullet{width: .2rem!important;height: .06rem!important;background: rgba(0,0,0,.35)!important;margin: 0 .035rem!important;border-radius: .04rem!important;}
  .banner .swiper-pagination-bullet-active{background: #ffc303!important;}
  .banner .swiper-box{border-radius: .22rem;}
</style>



// WEBPACK FOOTER //
// src/page/home/home.vue